import { nanoid } from "nanoid";
import type { QCFormValues } from "./QCForm";

export const qcFormSamples: QCFormValues[] = [
  {
    name: "ມາດຕະຖານ QC ການຜະລິດ",
    description: "ມາດຕະຖານການກວດສອບຄຸນນະພາບໃນຂະບວນການຜະລິດ",
    workTypeId: "",
    workStage: "ໃນຂະບວນການຜະລິດ",
    departmentId: null,
    inspectorPositionId: null,
    status: "active",
    requirePhoto: true,
    requireNotesOnFail: true,
    passCriteria: "ຜ່ານທຸກຂໍ້ກວດສອບຕາມມາດຕະຖານ",
    failCriteria: "ມີຂໍ້ໃດຂໍ້ໜຶ່ງບໍ່ຜ່ານຕາມມາດຕະຖານ",
    actionOnFail: "ແກ້ໄຂທັນທີແລະກວດສອບອີກຄັ້ງ",
    notifyPositionId: null,
    items: [
      {
        id: nanoid(),
        title: "ສີຕ້ອງຕົງຕາມແບບ",
        description: "ກວດສອບວ່າສີຕົງຕາມຕາຕະລາງສີທີ່ກໍານົດ",
        orderIndex: 0,
        isRequired: true,
        passCriteria: "ສີຕົງຕາມຕາຕະລາງທີ່ກໍານົດ",
        failCriteria: "ສີບໍ່ຕົງຕາມຕາຕະລາງ",
      },
      {
        id: nanoid(),
        title: "ຂະໜາດຕ້ອງຖືກຕ້ອງ",
        description: "ກວດສອບຂະໜາດຕາມຂໍ້ກໍານົດໃນແບບ",
        orderIndex: 1,
        isRequired: true,
        passCriteria: "ຂະໜາດຖືກຕ້ອງຕາມຂໍ້ກໍານົດ",
        failCriteria: "ຂະໜາດບໍ່ຖືກຕ້ອງ",
      },
      {
        id: nanoid(),
        title: "ບໍ່ມີຕໍາແໜ່ງ",
        description: "ກວດສອບວ່າບໍ່ມີຕໍາແໜ່ງຫຼືຈຸດບົກພ່ອງ",
        orderIndex: 2,
        isRequired: true,
        passCriteria: "ບໍ່ມີຕໍາແໜ່ງເຫັນຊັດ",
        failCriteria: "ພົບຕໍາແໜ່ງຫຼືຈຸດບົກພ່ອງ",
      },
    ],
  },
  {
    name: "ມາດຕະຖານ QC ການແພັກ",
    description: "ມາດຕະຖານການກວດສອບກ່ອນແພັກສິນຄ້າ",
    workTypeId: "",
    workStage: "ກ່ອນແພັກ",
    departmentId: null,
    inspectorPositionId: null,
    status: "active",
    requirePhoto: false,
    requireNotesOnFail: true,
    passCriteria: "ຜ່ານຢ່າງໜ້ອຍ 80% ຂອງຂໍ້ກວດສອບ",
    failCriteria: "ມີຂໍ້ກວດສອບທີ່ຈໍາເປັນບໍ່ຜ່ານ",
    actionOnFail: "ສົ່ງໃຫ້ຫົວໜ້າເບິ່ງ",
    notifyPositionId: null,
    items: [
      {
        id: nanoid(),
        title: "ຄຸນນະພາບວັດສະດຸດີ",
        description: "ກວດສອບຄຸນນະພາບວັດສະດຸວ່າດີ",
        orderIndex: 0,
        isRequired: true,
        passCriteria: "ວັດສະດຸມີຄຸນນະພາບດີ",
        failCriteria: "ວັດສະດຸມີບັນຫາ",
      },
      {
        id: nanoid(),
        title: "ການບັນຈຸຖືກຕ້ອງ",
        description: "ກວດສອບວ່າການບັນຈຸຖືກຕ້ອງ",
        orderIndex: 1,
        isRequired: true,
        passCriteria: "ບັນຈຸຕາມມາດຕະຖານ",
        failCriteria: "ບັນຈຸບໍ່ຖືກຕ້ອງ",
      },
      {
        id: nanoid(),
        title: "ປ້າຍຊື່ຕ້ອງຊັດເຈນ",
        description: "ກວດສອບວ່າປ້າຍຊື່ມີຂໍ້ມູນຊັດເຈນ",
        orderIndex: 2,
        isRequired: false,
        passCriteria: "ປ້າຍຊື່ມີຂໍ້ມູນຄົບຖ້ວນ",
        failCriteria: "ປ້າຍຊື່ບໍ່ຊັດເຈນ",
      },
    ],
  },
  {
    name: "ມາດຕະຖານ QC ການຈັດສົ່ງ",
    description: "ມາດຕະຖານການກວດສອບກ່ອນຈັດສົ່ງ",
    workTypeId: "",
    workStage: "ກ່ອນສົ່ງ",
    departmentId: null,
    inspectorPositionId: null,
    status: "active",
    requirePhoto: true,
    requireNotesOnFail: true,
    passCriteria: "ຜ່ານຂໍ້ກວດສອບທີ່ຈໍາເປັນທັງໝົດ",
    failCriteria: "ບໍ່ຜ່ານຕາມມາດຕະຖານກໍານົດ",
    actionOnFail: "ຢຸດການສົ່ງຈົນກວ່າຈະແກ້ໄຂແລ້ວ",
    notifyPositionId: null,
    items: [
      {
        id: nanoid(),
        title: "ສະອາດແລະບໍ່ມີຄວາມເສຍຫາຍ",
        description: "ກວດສອບວ່າສິນຄ້າສະອາດແລະບໍ່ມີຄວາມເສຍຫາຍ",
        orderIndex: 0,
        isRequired: true,
        passCriteria: "ສິນຄ້າສະອາດ ແລະ ບໍ່ມີຄວາມເສຍຫາຍ",
        failCriteria: "ພົບຄວາມເສຍຫາຍ",
      },
      {
        id: nanoid(),
        title: "ການຕິດຕໍ່ສົມບູນ",
        description: "ກວດສອບການຕິດຕໍ່ວ່າສົມບູນ",
        orderIndex: 1,
        isRequired: true,
        passCriteria: "ການຕິດຕໍ່ສົມບູນ",
        failCriteria: "ການຕິດຕໍ່ບໍ່ສົມບູນ",
      },
      {
        id: nanoid(),
        title: "ການບັນຈຸຖືກຕ້ອງ",
        description: "ກວດສອບການບັນຈຸ",
        orderIndex: 2,
        isRequired: true,
        passCriteria: "ບັນຈຸຖືກຕ້ອງ",
        failCriteria: "ບັນຈຸບໍ່ຖືກຕ້ອງ",
      },
      {
        id: nanoid(),
        title: "ປ້າຍການຈັດສົ່ງ",
        description: "ກວດສອບວ່າມີປ້າຍການຈັດສົ່ງຖືກຕ້ອງ",
        orderIndex: 3,
        isRequired: false,
        passCriteria: "ປ້າຍຖືກຕ້ອງ",
        failCriteria: "ປ້າຍບໍ່ຖືກຕ້ອງ",
      },
    ],
  },
  {
    name: "ມາດຕະຖານ QC ການຮັບສິນຄ້າ",
    description: "ມາດຕະຖານການກວດສອບເມື່ອຮັບສິນຄ້າ",
    workTypeId: "",
    workStage: "ຫຼັງຮັບ",
    departmentId: null,
    inspectorPositionId: null,
    status: "draft",
    requirePhoto: true,
    requireNotesOnFail: true,
    passCriteria: "ຜ່ານອີງຕາມມາດຕະຖານທີ່ກໍານົດໄວ້",
    failCriteria: "ບໍ່ຜ່ານຕາມມາດຕະຖານກໍານົດ",
    actionOnFail: "ບັນທຶກແລະລາຍງານ",
    notifyPositionId: null,
    items: [
      {
        id: nanoid(),
        title: "ຈໍານວນຕົກລົງກັບໃບບິນ",
        description: "ກວດສອບຈໍານວນວ່າຕົກລົງກັບໃບບິນ",
        orderIndex: 0,
        isRequired: true,
        passCriteria: "ຈໍານວນຕົກລົງກັບໃບບິນ",
        failCriteria: "ຈໍານວນບໍ່ຕົກລົງ",
      },
      {
        id: nanoid(),
        title: "ຄຸນນະພາບສິນຄ້າ",
        description: "ກວດສອບຄຸນນະພາບຂອງສິນຄ້າ",
        orderIndex: 1,
        isRequired: true,
        passCriteria: "ຄຸນນະພາບດີ",
        failCriteria: "ຄຸນນະພາບບໍ່ດີ",
      },
      {
        id: nanoid(),
        title: "ການບັນຈຸຖືກຕ້ອງ",
        description: "ກວດສອບການບັນຈຸ",
        orderIndex: 2,
        isRequired: false,
        passCriteria: "ບັນຈຸຖືກຕ້ອງ",
        failCriteria: "ບັນຈຸບໍ່ຖືກຕ້ອງ",
      },
    ],
  },
  {
    name: "ມາດຕະຖານ QC ຄຸນນະພາບສິນຄ້າ",
    description: "ມາດຕະຖານການກວດສອບຄຸນນະພາບສິນຄ້າທົ່ວໄປ",
    workTypeId: "",
    workStage: "ຫຼັງຜະລິດ",
    departmentId: null,
    inspectorPositionId: null,
    status: "active",
    requirePhoto: false,
    requireNotesOnFail: false,
    passCriteria: "ຜ່ານທຸກຂໍ້ກວດສອບ",
    failCriteria: "ມີຂໍ້ໃດຂໍ້ໜຶ່ງບໍ່ຜ່ານ",
    actionOnFail: "ແກ້ໄຂທັນທີແລະກວດສອບອີກຄັ້ງ",
    notifyPositionId: null,
    items: [
      {
        id: nanoid(),
        title: "ຄຸນນະພາບວັດສະດຸ",
        description: "ກວດສອບຄຸນນະພາບວັດສະດຸ",
        orderIndex: 0,
        isRequired: true,
        passCriteria: "ຄຸນນະພາບດີ",
        failCriteria: "ຄຸນນະພາບບໍ່ດີ",
      },
      {
        id: nanoid(),
        title: "ການຜະລິດຖືກຕ້ອງ",
        description: "ກວດສອບການຜະລິດ",
        orderIndex: 1,
        isRequired: true,
        passCriteria: "ຜະລິດຕາມມາດຕະຖານ",
        failCriteria: "ຜະລິດບໍ່ຕາມມາດຕະຖານ",
      },
      {
        id: nanoid(),
        title: "ບໍ່ມີຕໍາແໜ່ງ",
        description: "ກວດສອບຕໍາແໜ່ງ",
        orderIndex: 2,
        isRequired: true,
        passCriteria: "ບໍ່ມີຕໍາແໜ່ງ",
        failCriteria: "ພົບຕໍາແໜ່ງ",
      },
      {
        id: nanoid(),
        title: "ສີຕົງຕາມຕາຕະລາງ",
        description: "ກວດສອບສີ",
        orderIndex: 3,
        isRequired: false,
        passCriteria: "ສີຕົງຕາມຕາຕະລາງ",
        failCriteria: "ສີບໍ່ຕົງ",
      },
      {
        id: nanoid(),
        title: "ຂະໜາດຖືກຕ້ອງ",
        description: "ກວດສອບຂະໜາດ",
        orderIndex: 4,
        isRequired: false,
        passCriteria: "ຂະໜາດຖືກຕ້ອງ",
        failCriteria: "ຂະໜາດບໍ່ຖືກຕ້ອງ",
      },
    ],
  },
];
